import { Lock } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";
import type { Hex } from "@/color/oklch";
import { toLch } from "@/color/oklch";
import { cn } from "@/ui/kit/cn";

export function Swatch({
  hex,
  selected,
  locked,
  size = "md",
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  hex: Hex;
  selected?: boolean;
  locked?: boolean;
  size?: "sm" | "md" | "lg";
}) {
  const light = toLch(hex).l > 0.62;
  return (
    <button
      type="button"
      className={cn(
        "relative shrink-0 rounded-md ring-1 ring-black/40 transition-transform hover:scale-[1.06] focus-visible:scale-[1.06]",
        size === "sm" && "size-5 rounded",
        size === "md" && "size-9",
        size === "lg" && "h-16 w-full rounded-lg hover:scale-100",
        selected && "ring-2 ring-accent ring-offset-2 ring-offset-panel",
        className,
      )}
      style={{ background: hex }}
      {...props}
    >
      {locked && (
        <Lock
          className={cn(
            "absolute right-0.5 bottom-0.5 size-2.5",
            light ? "text-black/60" : "text-white/70",
          )}
        />
      )}
    </button>
  );
}
